import api from './api';

export async function getReceitasPaciente(codPac) {
  const { data } = await api.get(`paciente/${codPac}/receitas`);

  if (data && !Array.isArray(data) && data.error) {
    throw new Error(data.error);
  }

  return Array.isArray(data) ? data : [];
}

export async function deleteReceita(codReceita) {
  const { data } = await api.delete(`receita/${codReceita}`);
  return data;
}

export async function atualizarControleReceita(codReceita, payload) {
  const { data } = await api.put(`receita/${codReceita}/controle`, payload);
  return data;
}

export async function solicitarPedidoReceita(codPac, payload) {
  const { data } = await api.post(`paciente/${codPac}/receitas/pedido`, payload);
  return data;
}
